import { useApi } from '@hooks/useApi';
import { PaymentControlsTypes, queryKeys } from '@utils/consts';
import { isError, mapControlType } from '@utils/apiHelpers';
import { PaymentControlApiParams } from './create';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { ApiError, PaymentControl } from '@root/globalTypes';

export const useUpdatePaymentControl = ({
  type,
  id,
  merchantId,
  callback,
}: {
  type: PaymentControlsTypes;
  id: string;
  merchantId: string;
  callback: () => void;
}) => {
  const { query } = useApi();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState<ApiError | null>(null);

  const { mutate, isPending } = useMutation({
    mutationFn: (controlData: PaymentControlApiParams): Promise<PaymentControl> => {
      return query({
        path: `v1/acquirer/merchants/${merchantId}/payment_controls/${mapControlType(type)}/${id}`,
        data: controlData,
        opt: {
          method: 'PUT',
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      if (isError(data)) {
        setApiError(data);
      } else {
        callback();
      }
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: [...queryKeys.paymentControls, merchantId, id],
      });
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
};
